import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    statusUrl: String,
    interval: { type: Number, default: 30000 },
  };

  connect() {
    if (this.element.dataset.state !== "pending") return;

    this.poll();
    this.timerId = setInterval(() => this.poll(), this.intervalValue);
  }

  disconnect() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }

  poll() {
    fetch(this.statusUrlValue, {
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      })
      .then((data) => {
        if (data.finished || (data.provisioning_status && data.provisioning_status !== "pending")) {
          window.location.reload();
        }
      })
      .catch(() => {});
  }
}
